import { observer, use$ } from '@legendapp/state/react';
import { Button, type ButtonProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { autoBetState$ } from '../../../state';

export type ConfigureAutoBetButtonProps = ButtonProps;

export const ConfigureAutoBetButton = observer(
  (props: ConfigureAutoBetButtonProps) => {
    const isBetting = use$(autoBetState$.isAutoBetting);
    const { t } = useTranslation();
    return (
      <Button
        disabled={isBetting}
        onClick={() => autoBetState$.openConfigureAutoBetModal()}
        size="lg"
        variant="outline"
        {...props}
      >
        {t('autobet.configureAutoBetButton.label')}
      </Button>
    );
  }
);
